module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/bOv7ee/tc-custom/9781623800680.jpg?1705580007734",
      "alt": "This image is the cover for the book Haciendo Promesas, Manteniendo la Roca Promesa"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Haciendo Promesas, Manteniendo la Roca Promesa\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("Volumen 2 de la serie Manteniendo la Roca Promesa")])])]), _c('p', [_vm._v("Todo lo que Shane Perkins siempre quiso fue ser un héroe. Sin embargo, tras la decisión que pudo haber acabado con su carrera de caer luchando, Shane vuelve a casa del hospital y se ve entre cuatro paredes vacías, con una montaña de dinero y un deseo ferviente de que alguien le eche de menos la próxima vez que sea herido en acto de servicio. Termina como agente en la pequeña ciudad de Levee Oaks y, adicto a la promesa de familia, hace un esfuerzo por reconciliarse con su veleidosa y problemática hermana Kimmy. Ella se gana la vida como bailarina y es su compañero de baile quien deja a Shane sin respiración a primera vista.")]), _vm._v(" "), _c('p', [_vm._v("Mikhail Vasilyovitch Bayul baila como un ángel, pero esconde un pasado de todo menos angelical. Desde que dejó Rusia solo ha hecho dos promesas: una, permanecer fuera de las calles y seguir limpio, y dos, llevar a su madre a algún lugar bonito antes de que muera. Hacer promesas a otra persona está completamente fuera de cuestión... Pero Mikhail nunca ha conocido a nadie como Shane. Ferviente, valeroso y humilde, Shane parece hablar el mismo idioma de Mikhail y nadie está más sorprendido que él de encontrarse con que las promesas es el mejor talento de Shane.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Amy Lane, Rocío Pérez García\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0